import type { ReactNode } from 'react'
import { AppErrorFallback } from '@buyscout/shared'
import * as Sentry from '@sentry/react'

export function AppErrorBoundary({ children }: { children: ReactNode }) {
  return <Sentry.ErrorBoundary fallback={<AppErrorFallback />}>{children}</Sentry.ErrorBoundary>
}
